import React from "react"

interface PopoverProps {
  children: React.ReactNode
}

interface PopoverTriggerProps {
  children: React.ReactNode
}

interface PopoverContentProps {
  children: React.ReactNode
  className?: string
}

export const Popover: React.FC<PopoverProps> = ({ children }) => {
  return <div className="dropdown dropdown-end">{children}</div>
}

export const PopoverTrigger: React.FC<PopoverTriggerProps> = ({ children }) => {
  return (
    <div tabIndex={0} role="button">
      {children}
    </div>
  )
}

export const PopoverContent: React.FC<PopoverContentProps> = ({ children, className }) => {
  return (
    <div
      tabIndex={0}
      className={`dropdown-content z-[1] card card-compact w-64 p-2 shadow bg-base-100 ${className || ""}`}
    >
      {children}
    </div>
  )
}
